import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TopLevelLayers } from 'src/app/menu/view-menu/top-level-layers';
import { ProcessingToolCSVModel } from 'src/app/models/ProcessingToolCSVModel';
import * as fileSaver from 'file-saver';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { UtilsService } from 'src/app/services/utils.service';
import { on } from 'process';

@Component({
  selector: 'app-export-processing-tool',
  templateUrl: './export-processing-tool.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class ExportProcessingToolComponent implements OnInit {

  @Input()
  model: ProcessingToolCSVModel;

  @Input()
  values: Map<string, string>[];

  constructor(private bsModalRef : BsModalRef,
    private messageModal: ModalControlService,
    public utilsService: UtilsService) { }

  ngOnInit(): void {
  }

  cancelExport():void {
    this.bsModalRef.hide();
  }

  static createModel(topLevelLayer :TopLevelLayers): ProcessingToolCSVModel{
    const modelToReturn: ProcessingToolCSVModel = new ProcessingToolCSVModel();
    modelToReturn.processingTool_attributes = topLevelLayer.processingTool_attributes;
    modelToReturn.fillTable();
    return modelToReturn;

  }

  static pushValues(topLevelLayer :TopLevelLayers): Map<string, string>[]{
    const valuesToReturn: Map<string, string>[] = [];
    const source = topLevelLayer.layers[0].olLayer.getSource();
    source.forEachFeature(feat => {
      valuesToReturn.push(feat.get("values"));
    });
    return valuesToReturn;
  }


  startExport(): void{
    const fileNameBeforeValidation = this.model.fileName;
    if (fileNameBeforeValidation.includes(".csv")){
      fileNameBeforeValidation.replace(".csv", "");
    }
    if (this.validForm(fileNameBeforeValidation)){
      const fileNameAfterValidation = fileNameBeforeValidation + ".csv";
      var rows = this.values;
      if (!rows || !rows.length) {
        return;
      }
      const keys = this.model.getCSVFileHeader();
      const csvContent =
        keys.join(this.model.fieldSeparator) + this.model.fieldSeparator +
        '\n' +
        rows.map(row => {
          let rowString: string = "";
          rowString += row["COM_2"].toString().replace(".", this.model.decimalSeparator) + this.model.fieldSeparator +
          row["COM_3"] + this.model.fieldSeparator.toString().replace(".", this.model.decimalSeparator);
          for (const attribute of this.model.processingTool_attributes){
            const onTable = this.model.table.find(field => field.name == attribute.displayName);
            if (onTable.checked){
              rowString += row[attribute.key].toString().replace(".", this.model.decimalSeparator) + this.model.fieldSeparator;
            }

          }

          return rowString;
          }).join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      fileSaver.saveAs(blob, fileNameAfterValidation);
    }
    this.bsModalRef.hide();
  }

  private validForm(fileNameBeforeValidation: string):boolean{
    if (!this.utilsService.validateFileName(fileNameBeforeValidation)){
      this.messageModal.showMesssageModal(
        'Processing Tool Export Menu',
        `Please define a valid file name.`
      )
      return false;
    }

    if (this.model.decimalSeparator == this.model.fieldSeparator){
      this.messageModal.showMesssageModal(
        'Processing Tool Export Menu',
        `Please define a different field and decimal separator.`
      )
      return false;
    }

    return true
  }


}
